import React from 'react';
import UniversalMobileNav from '../../../components/Dashboard/MobileNav';

const MobileNav = (props) => {
  return <UniversalMobileNav portalType="shop" {...props} />;
};

export default MobileNav;
